import React, { useState } from 'react';
import { ScrollView, View } from 'react-native';
import { useRoute } from '@react-navigation/native';

import tw from '@/styles/tailwind';
import Text from '@/components/Text';
import { MonthSelectorDropdown, MonthSelectorModal } from '@/components/Forms/MonthSelector';
import useActiveAdminCommunity from '@/hooks/useActiveAdminCommunity';
import { REPORTS, ReportKey } from './registry';

// Pantalla de detalle única y compartida. Resuelve el reporte por `reportKey` (registry)
// y la comunidad por param (panel Vinte: desarrollo elegido) o por hook (admin: comunidad activa).
export default function ReportDetailScreen() {
  const route = useRoute<any>();
  const reportKey = route.params?.reportKey as ReportKey;

  const { communityId: adminCommunityId } = useActiveAdminCommunity();
  const communityId = route.params?.communityId ?? adminCommunityId;

  const [date, setDate] = useState(new Date());
  const [showMonthModal, setShowMonthModal] = useState(false);

  const entry = REPORTS[reportKey];

  if (!entry) {
    return <Text style={tw`my-8 text-lg text-center text-gray-400`}>Reporte no encontrado</Text>;
  }

  const Report = entry.component;

  return (
    <ScrollView style={tw`flex-1 bg-background`}>
      <View style={tw`row justify-between items-center px-5 py-4`}>
        <Text style={tw`text-xl font-600 text-secondary flex-1 pr-3`}>{entry.title}</Text>

        {
          entry.period === 'month' &&
            <MonthSelectorDropdown
              selectedDate={date}
              onPress={() => setShowMonthModal(true)}
              style={{ container: `w-44 py-2` }}
            />
        }
      </View>

      <Report communityId={communityId} date={date} />

      {
        showMonthModal &&
          <MonthSelectorModal
            onRequestClose={() => setShowMonthModal(false)}
            selectedDate={date}
            onChange={d => {
              setShowMonthModal(false);
              setDate(d);
            }}
          />
      }
    </ScrollView>
  );
}
